import React from 'react';
import { Switch } from '../ui/switch';

export const PrivacySettingRow = ({ id, icon: Icon, label, description, descriptionId, checked, busy, onChange }) => (
  <div className="settings-privacy-row" data-testid={`${id}-row`}>
    <span className="privacy-row-icon" aria-hidden="true" data-testid={`${id}-icon`}><Icon size={28} strokeWidth={1.7} /></span>
    <div className="privacy-row-copy">
      <label id={`${id}-label`} htmlFor={id} data-testid={`${id}-label`}>{label}</label>
      <p id={descriptionId} data-testid={descriptionId}>{description}</p>
    </div>
    <Switch id={id} className="privacy-toggle" data-testid={`${id}-toggle`} checked={checked} disabled={busy} onCheckedChange={onChange} aria-labelledby={`${id}-label`} aria-describedby={descriptionId} />
  </div>
);